import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component CloseDocumentIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <CloseDocumentIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <CloseDocumentIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const CloseDocumentIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      data-testid="CloseDocumentIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M5 4h10.19L19 7.891V20H5V4zm11.03-2H5a2 2 0 00-2 2v16a2 2 0 002 2h14a2 2 0 002-2V7.075L16.03 2zM9.707 9.293a1 1 0 00-1.414 1.414L10.586 13l-2.293 2.293a1 1 0 101.414 1.414L12 14.414l2.293 2.293a1 1 0 001.414-1.414L13.414 13l2.293-2.293a1 1 0 00-1.414-1.414L12 11.586 9.707 9.293z"
        clipRule="evenodd"
      />
    </svg>
  )
);
CloseDocumentIcon.displayName = "CloseDocumentIcon";
export default CloseDocumentIcon;
